import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import {
  ReadPackagesPriceRangeRequestDto,
  ReadPackagesPriceRangeResponseDto,
} from "./dtos";

export const readPackagesPriceRange = async (
  data: ReadPackagesPriceRangeRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReadPackagesPriceRangeResponseDto>> => {
  return await http.post<ReadPackagesPriceRangeResponseDto>(
    `/packages/price-range`,
    {
      ...data,
      _method: "GET",
    },
    { cancelToken }
  );
};
